export var syncNowCheckBoxDetails = [
    {
        item: { display: "MF Central", value: "mf_central" },
        desc: "Link folios via MF Central. You need client’s OTP consent.",
        lastSync: "NA",
    },
    //  {
    //   item: { display: "Upload CAS", value: "upload_cas" },
    //   desc: "Use when client has shared CAS PDF statement",
    //   lastSync: "24 November 2024",
    // },
    // {
    //   item: { display: "Folio Upload", value: "folio_upload" },
    //   desc: "Download the template, fill and upload it here.",
    //   lastSync: "24 November 2024",
    // },
];
export var EScreenState;
(function (EScreenState) {
    EScreenState["SYNC_SUCCESS"] = "SYNC_SUCCESS";
    EScreenState["SYNC_FAILURE"] = "SYNC_FAILURE";
    EScreenState["GENERATE_OTP"] = "GENERATE_OTP";
})(EScreenState || (EScreenState = {}));
export var EFilterValues;
(function (EFilterValues) {
    EFilterValues["CLIENT_TIER"] = "tier";
    EFilterValues["INVESTMENT_VALUE"] = "investmentvalue";
})(EFilterValues || (EFilterValues = {}));
